export default __webpack_public_path__ + "static/style2.1_Elena-a8edcdb5525ccc85a77c1647b9573a79.wav";